import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

const ZOOM_STEP:number = 0.25;
const DEFAULT_ZOOM:number = 1;
const MIN_ZOOM:number = 0.5;
const MAX_ZOOM:number = 4;

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {
  @Input() tempFile: string;
  @Input() showButtons: boolean = true;
  @Output() downloadButtonClick = new EventEmitter<void>();
  /** pdf.js could not open the file (not a PDF, damaged, password-protected). Without it the
   *  viewer just stays empty, and the host cannot say why. */
  @Output() loadError = new EventEmitter<any>();

  page: number = 1;
  totalPages: number;
  public pdfZoom:number = DEFAULT_ZOOM;
  /** The zoom the document opens at; the Reset button shows whenever it is anything else. */
  public readonly defaultZoom: number = DEFAULT_ZOOM;
  public showToolTipDelay: number = 400;
  public pageScale: number = 100;

  constructor(private readonly host: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
  }

  /** The Reset button: the opening size, on the same part of the document (a long PDF does
   *  not jump back to page one), with the page's left edge back in view. */
  resetZoom(): void {
    const scroller = this.host.nativeElement.querySelector('.ng2-pdf-viewer-container') as HTMLElement;
    const fraction = scroller && scroller.scrollHeight ? scroller.scrollTop / scroller.scrollHeight : 0;
    const oldHeight = scroller ? scroller.scrollHeight : 0;
    this.zoomReset();
    if (!scroller) { return; }
    // The PDF re-renders asynchronously: wait for its height to change (up to half a second).
    let frames = 0;
    const settle = () => {
      if (scroller.scrollHeight === oldHeight && ++frames < 30) { requestAnimationFrame(settle); return; }
      scroller.scrollLeft = 0;
      scroller.scrollTop = fraction * scroller.scrollHeight;
    };
    requestAnimationFrame(settle);
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }

  /** One wheel notch in (+1) or out (-1). */
  public zoomBy(direction: number)
	{
    const next = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, this.pdfZoom + direction * ZOOM_STEP));
    this.pdfZoom = next;
    this.pageScale = Math.round(next * 100);
	}

  public zoomIn()
	{
    this.pdfZoom = this.pdfZoom + 0.25;
    this.pageScale = this.pageScale + 25;
	}

  public zoomReset()
	{
    this.pdfZoom = 1;
    this.pageScale = 100;
	}

	public zoomOut()
	{
    if (this.pdfZoom > 1) {
      this.pdfZoom = this.pdfZoom - 0.25;
      this.pageScale = this.pageScale - 25;
   }
	}

  public downloadPdf() {
    this.downloadButtonClick.emit();
  }
}
